var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4168_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 52.1101L0 96.7768H44.6667L44.6667 52.1101L14.889 52.1101C14.889 35.691 28.2476 22.3323 44.6667 22.3323V7.44336C20.036 7.44336 0 27.4794 0 52.1101V52.1101Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.196 22.3323V7.44336C79.5651 7.44336 59.5291 27.4794 59.5291 52.1101L59.5291 96.7768H104.196L104.196 52.1101L74.4181 52.1101C74.4181 35.691 87.7767 22.3323 104.196 22.3323V22.3323Z",
    fill: "#FFC846"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4168_877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.222,
    height: 104.222,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.0de5c2dec95278b2269ecabb6ec0bddf.svg";
export { ForwardRef as ReactComponent };